import Shuffle from 'shufflejs';
import shave from 'shave';

$(document).ready(function () {

    if (document.querySelector('.shuffle-container')) {
        if (document.querySelector('.card-content-text')) {
            shave('.card-content-text', '140');
        }
        var shuffles = new Shuffle(document.querySelector('.shuffle-container'), {
            itemSelector: '.shuffle-item',
            sizer: '.shuffle-sizer'
        });


        $('.filter-options').change(function () {
            shuffles.filter($(this).find(':selected').attr('data-group'));


        });

    }
});


